import {Controller} from '@stimulus/core'
require('../../../../vendor/front/vendor/slick-carousel/slick/slick')
require('../../../../vendor/front/js/hs.core')
require('../../../../vendor/front/js/hs.slick-carousel')

export default class extends Controller {
  connect() {
    if (this.isInitialized()) {
      return false
    }

    this.slickCarousel = $.HSCore.components.HSSlickCarousel.init(this.$element)

    return true
  }

  isInitialized() {
    return this.$element.hasClass('slick-initialized')
  }

  get $element() {
    return $(this.element)
  }
}
